module.exports = __webpack_public_path__ + "media/images/dashboard_logo-618631196d7bf8b63078498a211c72a0.png";